module.exports = __webpack_public_path__ + "static/MartiManyalichMDPhDSPAIN-9984fc42a7575e5d048d4e461a35b221.jpg";